(function () {
  'use strict';

  if (window.PGCartDrawerControllerV126) return;
  window.PGCartDrawerControllerV126 = true;

  var media = window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.medium
    ? window.PXUTheme.media_queries.medium
    : window.matchMedia('(max-width: 798px)');
  var backdrop = null;
  var pendingAdd = null;
  var fallbackTimer = null;
  var countObserver = null;

  function isMobile() {
    return Boolean(media && media.matches);
  }

  function cartCount() {
    var counts = Array.prototype.map.call(document.querySelectorAll('.cart_count'), function (node) {
      var match = String(node.textContent || '').match(/\d+/);
      return match ? Number(match[0]) : 0;
    });
    return counts.length ? Math.max.apply(Math, counts) : 0;
  }

  function ensureBackdrop() {
    if (backdrop && backdrop.isConnected) return backdrop;
    backdrop = document.querySelector('.pg-drawer-backdrop[data-pg-v126]');
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'pg-drawer-backdrop';
    backdrop.setAttribute('data-pg-v126', '');
    backdrop.addEventListener('click', closeDrawer);
    document.body.appendChild(backdrop);
    return backdrop;
  }

  function shimDrawers() {
    if (!isMobile()) return;
    document.querySelectorAll('.cart-container .cart_content').forEach(function (drawer) {
      if (drawer.dataset.pgV113Shimmed === '1') return;
      drawer.dataset.pgV113Shimmed = '1';
      drawer.classList.add('pg-mobile-drawer');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.appendChild(drawer);
      if (!drawer.querySelector('.pg-drawer-close')) {
        var close = document.createElement('button');
        close.className = 'pg-drawer-close';
        close.type = 'button';
        close.setAttribute('aria-label', 'Close cart');
        close.innerHTML = '&times;';
        close.addEventListener('click', closeDrawer);
        drawer.insertBefore(close, drawer.firstChild);
      }
    });
  }

  function currentMobileDrawer() {
    var drawers = document.querySelectorAll('.pg-mobile-drawer');
    for (var index = 0; index < drawers.length; index += 1) {
      if (drawers[index].querySelector('form[data-cart-form="mini-cart"], .mini-cart__item, .cart_subtotal')) return drawers[index];
    }
    return drawers[0] || null;
  }

  function openMobileDrawer() {
    shimDrawers();
    var drawer = currentMobileDrawer();
    if (!drawer) return false;
    document.querySelectorAll('.pg-mobile-drawer.pg-open').forEach(function (node) {
      if (node !== drawer) {
        node.classList.remove('pg-open');
        node.setAttribute('aria-hidden', 'true');
      }
    });
    ensureBackdrop().classList.add('pg-on');
    drawer.classList.add('pg-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pg-drawer-open');
    return true;
  }

  function visibleDesktopCartContainer() {
    var selectors = ['#header .cart-container', '.sticky_nav .cart-container', '.top-bar .cart-container'];
    for (var index = 0; index < selectors.length; index += 1) {
      var node = document.querySelector(selectors[index]);
      if (!node) continue;
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0) return node;
    }
    return document.querySelector('.cart-container');
  }

  function openDrawer() {
    if (isMobile()) return openMobileDrawer();
    var container = visibleDesktopCartContainer();
    if (!container) return false;
    container.classList.add('active_link');
    return true;
  }

  function closeDrawer() {
    document.querySelectorAll('.pg-mobile-drawer.pg-open').forEach(function (drawer) {
      drawer.classList.remove('pg-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    if (backdrop) backdrop.classList.remove('pg-on');
    document.body.classList.remove('pg-drawer-open', 'blocked-scroll');
    document.querySelectorAll('.cart-container.active_link').forEach(function (container) {
      container.classList.remove('active_link');
    });
  }

  function clearPending() {
    window.clearTimeout(fallbackTimer);
    fallbackTimer = null;
    pendingAdd = null;
  }

  function markCustomerAdd() {
    pendingAdd = {
      startedAt: Date.now(),
      countBefore: cartCount(),
      confirmed: false
    };
    window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(function () {
      if (!pendingAdd) return;
      if (pendingAdd.confirmed || cartCount() > pendingAdd.countBefore) openDrawer();
      clearPending();
    }, 15000);
  }

  function confirmCustomerAdd() {
    if (!pendingAdd || Date.now() - pendingAdd.startedAt > 30000) {
      clearPending();
      return;
    }
    pendingAdd.confirmed = true;
    window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(function () {
      if (!pendingAdd) return;
      openDrawer();
      clearPending();
    }, 700);
  }

  function explicitCustomerAdd() {
    if (!pendingAdd) {
      pendingAdd = {
        startedAt: Date.now(),
        countBefore: Math.max(0, cartCount() - 1),
        confirmed: true
      };
    } else {
      pendingAdd.confirmed = true;
    }
    window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(function () {
      openDrawer();
      clearPending();
    }, 450);
  }

  function checkCountAfterAdd() {
    if (!pendingAdd) return;
    if (cartCount() <= pendingAdd.countBefore) return;
    openDrawer();
    clearPending();
  }

  function observeCartCounts() {
    if (!window.MutationObserver) return;
    if (countObserver) countObserver.disconnect();
    countObserver = new MutationObserver(checkCountAfterAdd);
    document.querySelectorAll('.cart_count').forEach(function (node) {
      countObserver.observe(node, { childList: true, characterData: true, subtree: true });
    });
  }

  function isProductAddControl(target) {
    if (!target || !target.closest) return false;
    var control = target.closest('.ajax-submit, .add_to_cart, .pg-cfg-next--atc, button[name="add"], input[name="add"], [data-add-to-cart]');
    if (!control) return false;
    if (control.closest('.cart_content, #pg-cart, [data-pg-complete-set-add]')) return false;
    return true;
  }

  function cartLink(target) {
    if (!target || !target.closest) return null;
    var link = target.closest('a[href$="/cart"], a[href*="/cart?"], a[href*="/cart#"]');
    if (!link) return null;
    if (link.closest('.pg-mobile-drawer') || link.classList.contains('pg-drawer-viewcart')) return null;
    if (!link.closest('#header, .sticky_nav, .top-bar, header, .header-section, .mobile_nav-fixed--true')) return null;
    return link;
  }

  function bindJquerySuccess() {
    if (!window.jQuery) return;
    window.jQuery(document).on('ajaxSuccess.pgCartDrawerV126', function (_event, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (/\/cart\/add\.js(?:[?#]|$)/.test(url) && pendingAdd) confirmCustomerAdd();
    });
    window.jQuery(document).on('ajaxError.pgCartDrawerV126', function (_event, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (/\/cart\/add\.js(?:[?#]|$)/.test(url) && pendingAdd) clearPending();
    });
  }

  function init() {
    if (isMobile()) shimDrawers();
    observeCartCounts();
    bindJquerySuccess();

    document.addEventListener('click', function (event) {
      var link = isMobile() ? cartLink(event.target) : null;
      if (link) {
        event.preventDefault();
        event.stopPropagation();
        openDrawer();
        return;
      }
      if (isProductAddControl(event.target)) markCustomerAdd();
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.closest('.cart_content, #pg-cart')) return;
      if (form.matches('form[action*="/cart/add"]') || form.querySelector('.ajax-submit, .add_to_cart, .pg-cfg-next--atc, [name="add"]')) markCustomerAdd();
    }, true);

    document.addEventListener('pg:cart-item-added', explicitCustomerAdd);
    document.addEventListener('cart:refresh', function () {
      if (pendingAdd) confirmCustomerAdd();
    });
    document.addEventListener('pg:cart-synchronised', checkCountAfterAdd);
    document.addEventListener('shopify:section:load', function () {
      if (isMobile()) shimDrawers();
      observeCartCounts();
    });

    if (media && typeof media.addEventListener === 'function') {
      media.addEventListener('change', function () {
        if (isMobile()) shimDrawers();
        else closeDrawer();
        observeCartCounts();
      });
    }
  }

  window.pgOpenDrawer = openDrawer;
  window.PGCartDrawerV126 = {
    open: openDrawer,
    close: closeDrawer,
    refresh: shimDrawers
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
